<template>
  <div class="wrapper">
    <div>
    <CRow class="mt-3">
      <div>  
      </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @has_icareyouth="handleHasIcareYouth"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_delete="false"
                            :is_uuid="false"
                            :btn_assign="true"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                            @assign="handleAssign"

                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
      <modalicareyouth></modalicareyouth>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_ikid_graduate.vue'
import axios from 'axios'

import ikid from '@/services/ikid'

import modalicareyouth from './ikids_modal_icare_youth';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'iKidsTable',
  components: { modalicareyouth, alertmodal, Datatable },
  data(){
    return{
      form:{
        name:'',
      },
      updateSubmit: false,
      largeModal:false,
      datas:[], 


      //start
      fields: [
          {key: 'firstname', label: 'fullname', sortable: false, },
          {key: 'name', label: 'icare', sortable: false, },
          {key: 'created_at', label:'date graduate', sortable: false, },
        //   {key: 'class_name', sortable: false, },
        //   {key: 'dob', sortable: false, },
        //   {key: 'is_active', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'created_at',
      sortByDesc: false,
      has_icareyouth: 0,
      permission: true,
      //end
    }
  },

  created() {
      //this.loadData()
      this.beforeDestroy()
  },
  
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE_IKID_GRADUATE', (data) => {
      if(data){
          this.loadData();  
      }
    });

   },
   
  methods: {
    beforeDestroy(){
        EventBus.$off('OPEN_MODAL_IKID_NOTE', this.listener)
        EventBus.$off('OPEN_MODAL_IKID', this.listener)
        EventBus.$off('OPEN_MODAL_MEMBER_ICARE_YOUTH', this.listener)
    },

    assign(id){
      console.log('assign icare ID= ' + id);
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
      var params = {title: 'Assign Icare Youth', mode:'edit',data:id}
      EventBus.$emit('OPEN_MODAL_MEMBER_ICARE_YOUTH', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END

    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        has_icareyouth: this.has_icareyouth,
      }

      ikid.getIkidDataSourceGraduate(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              has_icareyouth: res.has_icareyouth
          }
          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    openModal: function () {

    },
    
    openShow(id){

    },

    openModalEdit(id){

    },

    deactivate(id){

    },

    reactivate(id){

    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    // handleIsActive(val) {
    //     this.is_active = val 
    //     this.loadData() 
    // },

    handleHasIcareYouth(val) {
        this.has_icareyouth = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.deactivate(val)       
    },
    handleAssign(val) {
        this.assign(val) 
    }, 
  }
}
</script>